import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'next-i18next'
import { Button } from 'stripe-ui'
import { useMemo } from 'react'
import { Rating } from '@/components/CoursewareModal/TrialFeedback/scatter'
import { IFeedbackFormProps } from '@/components/CoursewareModal/TrialFeedback/type'

export default function FormForStandardClass({
  onSubmit,
  viewData,
}: IFeedbackFormProps) {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: 'onSubmit',
    defaultValues: viewData
      ? viewData
      : {
          coach_rating: undefined,
          other_notes: '',
          is_anonymous: false,
        },
  })

  const { t } = useTranslation('my-class')
  const disabled = useMemo(() => !!viewData, [viewData])

  return (
    <div className="flex flex-col items-center px-20 py-3">
      <h2 className="text-xl mb-3 font-semibold">
        {t('trial_feedback.title')}
      </h2>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col space-y-3"
      >
        <div className="relative flex space-x-2 items-center">
          <div className="text-lg font-semibold w-64 text-left">
            {t('trial_feedback.coach_rating')}
          </div>
          <Controller
            rules={{
              required: true,
            }}
            control={control}
            name="coach_rating"
            render={({ field: { onChange, value } }) => {
              return (
                <Rating disabled={disabled} onChange={onChange} value={value} />
              )
            }}
          />
          {errors && errors.coach_rating && (
            <div className="absolute text-red-600 -right-1 transform translate-x-full">
              {t('trial_feedback.please_fill')}
            </div>
          )}
        </div>
        <div>
          <div className="text-lg font-semibold w-64 text-left">
            {t('trial_feedback.other_notes')}
          </div>
          <Controller
            control={control}
            name="other_notes"
            render={({ field: { onChange, value } }) => {
              return (
                <div className="mt-2">
                  <textarea
                    maxLength={1000}
                    defaultValue={value}
                    onChange={onChange}
                    disabled={disabled}
                    className="textarea h-32 w-full textarea-bordered"
                  />
                </div>
              )
            }}
          />
        </div>

        {!disabled && (
          <div className="flex items-center justify-center space-x-2">
            <Controller
              control={control}
              render={({ field: { onChange } }) => {
                return (
                  <div>
                    <input
                      id={'anonymous'}
                      type={'checkbox'}
                      className={'mr-2 rounded'}
                      onChange={onChange}
                    />
                    <label htmlFor={'anonymous'}>
                      {t('submit_anonymously')}
                    </label>
                  </div>
                )
              }}
              name={'is_anonymous'}
            />

            <Button type="submit" variant="brand">
              {t('course_form.submit', { ns: 'common' })}
            </Button>
          </div>
        )}
      </form>
    </div>
  )
}
